const buildSrcSet = (slug, widths, ext) =>
  widths.map((width) => `/images/products/${slug}-${width}.${ext} ${width}w`).join(", ");

const mainWidths = [480, 768, 1100, 1376];
const attackWidths = [480, 768, 960, 1200];
const heroLeftWidths = [480, 768, 1100, 1200];
const boxArtWidths = [400, 768, 1024];
const resultWidths = [400, 800];

export const productImages = {
  main: {
    alt: "Debt Collector Kill Switch - Ultimate Debt Collector Attack System.",
    width: 1376,
    height: 768,
    fallback: "/images/products/debt-collector-kill-switch-main.jpg",
    preload: "/images/products/debt-collector-kill-switch-main-1100.webp",
    webpSrcSet: buildSrcSet("debt-collector-kill-switch-main", mainWidths, "webp"),
    jpgSrcSet: buildSrcSet("debt-collector-kill-switch-main", mainWidths, "jpg"),
  },
  attack: {
    alt: "Debt Collector Kill Switch attack system process graphic",
    width: 1200,
    height: 896,
    fallback: "/images/products/kill-switch-attack-system.jpg",
    webpSrcSet: buildSrcSet("kill-switch-attack-system", attackWidths, "webp"),
    jpgSrcSet: buildSrcSet("kill-switch-attack-system", attackWidths, "jpg"),
  },
  heroLeft: {
    alt: "Stop! Never pay a debt collector - make them prove they have the legal right to collect",
    width: 1200,
    height: 896,
    fallback: "/images/products/debt-collector-kill-switch-hero-left.jpg",
    preload: "/images/products/debt-collector-kill-switch-hero-left-1100.webp",
    webpSrcSet: buildSrcSet("debt-collector-kill-switch-hero-left", heroLeftWidths, "webp"),
    jpgSrcSet: buildSrcSet("debt-collector-kill-switch-hero-left", heroLeftWidths, "jpg"),
  },
  boxArt: {
    alt: "Debt Collector Kill Switch is Done For You.",
    width: 1024,
    height: 1024,
    fallback: "/images/products/debt-collector-kill-switch-box-art.jpg",
    webpSrcSet: buildSrcSet("debt-collector-kill-switch-box-art", boxArtWidths, "webp"),
    jpgSrcSet: buildSrcSet("debt-collector-kill-switch-box-art", boxArtWidths, "jpg"),
  },
  resultCollection1: {
    alt: "Customer collection removal result - dispute letter outcome 1",
    width: 718,
    height: 776,
    fallback: "/images/products/customer-result-collection-1.jpg",
    webpSrcSet: buildSrcSet("customer-result-collection-1", resultWidths, "webp"),
    jpgSrcSet: buildSrcSet("customer-result-collection-1", resultWidths, "jpg"),
  },
  resultCollection2: {
    alt: "Customer collection removal result - dispute letter outcome 2",
    width: 1122,
    height: 1402,
    fallback: "/images/products/customer-result-collection-2.jpg",
    webpSrcSet: buildSrcSet("customer-result-collection-2", resultWidths, "webp"),
    jpgSrcSet: buildSrcSet("customer-result-collection-2", resultWidths, "jpg"),
  },
  resultCollection3: {
    alt: "Customer collection removal result - dispute letter outcome 3",
    width: 671,
    height: 853,
    fallback: "/images/products/customer-result-collection-3.jpg",
    webpSrcSet: buildSrcSet("customer-result-collection-3", resultWidths, "webp"),
    jpgSrcSet: buildSrcSet("customer-result-collection-3", resultWidths, "jpg"),
  },
  resultCollection4: {
    alt: "Customer collection removal result - dispute letter outcome 4",
    width: 706,
    height: 875,
    fallback: "/images/products/customer-result-collection-4.jpg",
    webpSrcSet: buildSrcSet("customer-result-collection-4", resultWidths, "webp"),
    jpgSrcSet: buildSrcSet("customer-result-collection-4", resultWidths, "jpg"),
  },
  resultCollection5: {
    alt: "Customer collection removal result - dispute letter outcome 5",
    width: 1122,
    height: 1402,
    fallback: "/images/products/customer-result-collection-5.jpg",
    webpSrcSet: buildSrcSet("customer-result-collection-5", resultWidths, "webp"),
    jpgSrcSet: buildSrcSet("customer-result-collection-5", resultWidths, "jpg"),
  },
};